import "../styles/styles.css"
function ToDoButton(){
    return(
        <button type="submit" className="botonEnviar">Send Task</button>
    )
}
export {ToDoButton}